import {
  Box,
  Button,
  CardMedia,
  Grid,
  IconButton,
  SelectChangeEvent,
  Theme,
  Typography,
} from '@mui/material';
import { Notes, NotesWithText, ProceedSaveLater, SubHeading } from './components';
import {
  Formik,
  setNestedObjectValues,
  useField,
  validateYupSchema,
  yupToFormErrors,
} from 'formik';
import MFSelectField from '../../lib/formik/SelectField';
import React, { ChangeEvent, useEffect, useState, useRef } from 'react';
import {
  AddressProofsMasters,
  AMC_APPROVER_CHECK_FOR_INDIVIDUAL,
  APMIFlow,
  APPLICANT_STATUS,
  applicantStatusMasters,
  APPLICATION_TYPE_FOR_DOCUMENTS,
  BankAccountProofsMasters,
  docInvalidCheck,
  ENABLE_KRA_DOCUMENT_FETCH,
  FINAL_DOC_UPLOAD_FORMATS,
  IdentityProofsMasters,
  IMAGE_UPLOAD_FORMATS,
  INVESTOR_IMAGE_UPLOAD_FORMATS,
  SAVE_LATER_VALIDATION_CHECK,
  subHeadingForDocumentDetails,
  USER_ROLES,
} from '../../utils/constant';
import { useDispatch, useSelector } from 'react-redux';
import { RootStateType } from '../../redux-store/reducers';
import {
  Applicant,
  ApplicationProps,
  Bank,
  Document,
  DocumentType,
  FileType,
  individuals_Poa_nonIndividuals_Documents,
  InvestorEditRouteLinkObj,
  KraDocumentType,
  NomineeType,
  RiskProfileMaster,
} from '../../redux-store/types/api-types';
import {
  createBankAccountFormNDPSM,
  getDocuments,
  isFormValidForSubmission,
  pennyDropVerification,
  updateApplication,
} from '../../redux-store/actions/application';
import { useHistory, useParams, useRouteMatch } from 'react-router';
import { FilePond, registerPlugin } from 'react-filepond';
import 'filepond/dist/filepond.min.css';
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';
import { documentDetailsSchema, documentDetailsSchemaForInvestorLogin } from '../../utils/schema';
import { logout, showError } from '../../redux-store/actions/auth';
import {
  checkEditiable,
  fieldValidateForInvestor,
  documentNameValidationCheckForMultipleDocumentsMandatory,
  getApplicantName,
  getInvestorRouteLinks,
  isMinor,
  saveForLater,
  saveForLaterInvestorPhotoCapture,
  sendApplication_Nri,
  checkNDPMSForIndusindBank,
  checkBankAccoutFieldEnableOrDisalble,
  documentTypeValidationCheckForDocumentNumberDocumentExpiryDate,
  documentNameValidationCheckForDocumentExpiryDate,
  documentTypeValidationCheckForDocumentNumberDocumentExpiryDateNominee,
  turnEditOnInDoc,
  isApplicantNRI,
  isCustodianICICIOrHDFC,
  isCustodianICICI,
  isCustodianHDFC,
  isBankAccountProofUploadedFromBankSection,
  shouldValidateUponSaveLater,
  getStep,
  checkRequired,
  checkDocumentNameInOptions,
  isCustodianAxis,
  getAllStrategiesByDistributorType,
  isCustodianKotak,
  mergeDocumentsWithCustodian,
  isInvestorOldOrNew,
  scrollToFieldByName,
  getFirstErrorField,
  isPhygital,
  nomineeDocEditCheck,
  checkAdvisoryFlow,
} from '../../utils/utilityFunctions';
import { getFieldTitle } from '../ApplicationDetails/DocumentDetails';
import { setLabels } from 'react-chartjs-2/dist/utils';
import { applicationComparison, applyRoleBasedStatus } from '../../utils/utilityFunctions';
import { useSnackbar } from 'notistack';
import {
  getMaskedAadhar,
  getNationalityList,
  MaskedAadharBody,
  MaskedAadharResponse,
  riskProfileMasterData,
} from '../../redux-store/actions';
import { nationaliyType } from '../../redux-store/types/mdms';
import { KraDocument } from './kraDocument';
import { GetStrategiesResponseBody } from '../../redux-store/types/strategies';
import { ConfirmationDialog, FileUploadDialog } from '../commonComponents';
import { MFTextField } from '../../lib/formik';
import { TextDatePicker } from '../../lib/DatePickerWithTextFeild';
import { SxProps } from '@mui/system';
import { OnEditDialogBox } from './additionalKYCDetails';
import { useCustodianData } from '../../utils/useCustodianData';
import { refLoginCheck } from '../Investments/investor-application';
import { useValidationOrConfigHook } from '../../utils/validationOrConfigHook';
import en from '../../lang/en-us';
import FieldValidationNote from './FieldValidationNote';
import { isPanDocAvaialbleForICICI } from '../../utils/utilityFunctions';
import { InvestorEditErrorObj } from '../../redux-store/reducers/investorEditSections';

registerPlugin(
  FilePondPluginImageExifOrientation,
  FilePondPluginImagePreview,
  FilePondPluginFileValidateSize,
  FilePondPluginFileValidateType
);

const FilePondHeader = ({
  multipleFiles,
  documentsLength,
  index,
  docName,
  options,
  required,
  sx,
}: {
  multipleFiles: string;
  documentsLength: number;
  index: number;
  docName: string;
  options: string[];
  required: string;
  sx?: SxProps<Theme>;
}): JSX.Element => {
  return (
    <>
      {multipleFiles === 'true' && documentsLength > 1 && (
        <Typography
          component="span"
          sx={{
            fontWeight: 500,
            fontSize: 14,
            ...sx,
          }}>
          Upload
          {index === 0
            ? ` front ${
                checkRequired(required) ||
                checkDocumentNameInOptions(docName, (options || []) as string[])
                  ? '*'
                  : ''
              }`
            : ` back ${
                checkRequired(required) ||
                (checkDocumentNameInOptions(docName, (options || []) as string[]) &&
                  documentNameValidationCheckForMultipleDocumentsMandatory(docName))
                  ? '*'
                  : documentNameValidationCheckForMultipleDocumentsMandatory(docName)
                  ? ''
                  : '(if applicable)'
              }`}
        </Typography>
      )}
    </>
  );
};

export const FileUpload = ({
  onFileChange,
  name,
  documentData,
  disabled,
  onFileUpload,
  onFileUploaded,
  displayReplaceButton = true,
  multipleFiles,
  index,
  documentsLength,
  isPhygitalDoc = false,
}: {
  onFileChange: (
    value: string,
    documentId: string,
    errorOnUpload?: boolean,
    removeFile?: boolean
  ) => void;
  name: string;
  documentData: documentDetails;
  disabled: boolean;
  onFileUpload: () => void;
  onFileUploaded: () => void;
  displayReplaceButton?: boolean;
  multipleFiles: string;
  index: number;
  documentsLength: number;
  isPhygitalDoc?: boolean;
}): JSX.Element => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [field, meta] = useField(name);
  const errorText = meta.error && meta.touched ? meta.error : '';
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [files, setFiles] = useState<any>([]);
  const authToken = useSelector((store: RootStateType) => store.auth.token);
  const { token: investorAuthToken } = useSelector((store: RootStateType) => store.investor);
  const dispatch = useDispatch();
  const { application } = useSelector((store: RootStateType) => store.application);
  const selectedCustodian = application?.custodian || '';
  const [open, setOpen] = useState({ show: false, message: '', code: '' });

  // eslint-disable-next-line
  const handleOpen = (result: any) => {
    setOpen({ show: true, message: result.message, code: result.code });
  };
  const handleClose = () => {
    setOpen({ show: false, message: '', code: '' });
  };
  useEffect(() => {
    if (files?.length === 0) {
      onFileChange('', documentData?.documentId || '', false);
    }
  }, [files]);
  const handleFileChange = (name: string, documentId: string) => {
    try {
      onFileChange(name, documentId);
    } catch (e) {
      onFileUploaded();
      console.error((e as Error).message);
    }
  };
  return (
    <>
      {!documentData.file ? (
        <Box
          sx={{
            '.filepond--credits': { display: 'none' },
            '.filepond--label-action': {
              textDecoration: 'none',
              fontSize: '14px',
            },
            '.filepond--drop-label': {
              cursor: disabled ? 'not-allowed' : 'pointer',
              pointerEvents: 'all',
            },
            '.filepond--file': {
              color: '#000',
              flexWrap: 'wrap',
              fontWeight: 500,
            },
            '.filepond--root': {
              mb: '0em',
              borderRadius: '5px',
              outline: 'none',
              transition: 'none !important',
              '&:focus-within': {
                outline: '2px solid #2057A6 !important',
                outlineOffset: '2px !important',
              },
            },
            pt: 4,
          }}>
          <FilePondHeader
            multipleFiles={multipleFiles}
            documentsLength={documentsLength}
            index={index}
            docName={documentData.documentName}
            options={documentData.options || []}
            required={documentData.required || ''}
          />
          <FilePond
            files={files}
            server={{
              process: {
                url: '/api/files/files',
                method: 'POST',
                headers: {
                  Authorization: `Bearer ${authToken || investorAuthToken}`,
                },
                onload: (response): string => {
                  const result = JSON.parse(response);
                  result?.name && result?.id && handleFileChange(result.name, result.id);
                  onFileUploaded();
                  return response;
                },
                ondata: (formData: FormData): FormData => {
                  if (isInvestorOldOrNew(documentData.documentType, selectedCustodian)) {
                    formData.append('fileSizeRestriction', '100');
                  }
                  return formData as unknown as FormData;
                },
                onerror: (response) => {
                  if (response) {
                    const result = JSON.parse(response);
                    if (result && result.message) {
                      onFileChange('', '', true, true);
                      handleOpen(result);
                    }
                  } else {
                    onFileChange('', '', true, true);
                    handleOpen({ code: '', message: en.networkText.unableToProcess });
                  }
                  return response;
                },
              },
            }}
            onaddfilestart={() => {
              onFileUpload();
            }}
            onaddfile={(error, file) => {
              if (error) {
                onFileChange('', '', true, true);
                onFileUploaded();
              }
            }}
            onprocessfile={(error, file) => {
              if (error) {
                if (error.code === 401) {
                  dispatch(logout());
                } else {
                  onFileUploaded();
                }
              }
            }}
            onupdatefiles={(fileItems) => {
              setFiles(fileItems);
            }}
            onprocessfilerevert={() => {
              onFileChange('', '', false, true);
            }}
            name="file"
            maxFileSize={
              isInvestorOldOrNew(documentData.documentType, selectedCustodian)
                ? '1MB'
                : isPhygitalDoc
                ? '20MB'
                : '2MB'
            }
            allowMultiple={false}
            maxFiles={1}
            acceptedFileTypes={
              isPhygitalDoc
                ? FINAL_DOC_UPLOAD_FORMATS
                : ['investorSignature', 'investorOldSignature'].includes(documentData.documentType)
                ? INVESTOR_IMAGE_UPLOAD_FORMATS
                : IMAGE_UPLOAD_FORMATS
            }
            labelIdle={`<span class="filepond--label-action">Upload</span>`}
            oninit={function (this: any) {
              const rootElement =
                this?.element || (this && typeof this.getFiles === 'function' ? this : null);

              const activePondNode = rootElement || document.querySelector('.filepond--root');
              if (!activePondNode) return;

              const dropLabel = activePondNode.querySelector('.filepond--drop-label');
              if (dropLabel) {
                dropLabel.setAttribute('role', 'button');
              }

              const inputElement = activePondNode.querySelector('input[type="file"]');
              if (inputElement) {
                inputElement.setAttribute(
                  'aria-label',
                  `Upload ${documentData?.documentName || 'File'}`
                );
              }
            }}
            labelFileTypeNotAllowed={'Invalid file type'}
            labelMaxFileSize={`Max file size is ${
              isPhygitalDoc
                ? '20MB'
                : isInvestorOldOrNew(documentData.documentType, selectedCustodian)
                ? '1MB'
                : '2MB'
            }`}
            fileValidateTypeLabelExpectedTypesMap={
              isPhygitalDoc
                ? { 'application/pdf': '.pdf' }
                : {
                    'image/jpeg': '.jpeg',
                    'image/jpg': '.jpg',
                    'image/png': '.png',
                    'application/pdf': '.pdf',
                  }
            }
            imagePreviewHeight={100}
            disabled={disabled}
            allowPaste={false}
          />
        </Box>
      ) : (
        <>
          <FilePondHeader
            multipleFiles={multipleFiles}
            documentsLength={documentsLength}
            index={index}
            options={documentData.options || []}
            docName={documentData.documentName}
            required={documentData?.required || ''}
            sx={{ mt: '30px' }}
          />
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              border: '1px dashed #AAB2BA',
              borderRadius: '6px',
              mt: multipleFiles === 'true' && documentsLength > 1 ? '1px' : '30px',
              minHeight: '65px',
            }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <CardMedia
                component="img"
                src={documentData.file.thumbnailUrl || '/images/photo-placeholder.jpg'}
                alt="aadhar"
                width="50"
                height="50"
                sx={{ display: 'flex', width: 'unset', mx: 1 }}
              />
            </Box>
            <Typography
              component="span"
              sx={{
                whiteSpace: 'pre-wrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                flex: 1,
              }}>
              {documentData.file.name}
            </Typography>
            <Box
              sx={{
                display: 'flex',
                '.MuiButton-root': { fontWeight: 500, fontSize: 14, p: 0, mr: 1 },
                flexWrap: 'wrap',
              }}>
              <Button
                sx={{
                  color: 'primary.main',
                  border: '1px dashed #2057A6',
                  mb: 1,
                }}
                onClick={() => window.open(documentData.file?.viewUrl)}>
                View
              </Button>
              {!disabled && displayReplaceButton && (
                <Button
                  variant="contained"
                  onClick={() => {
                    onFileChange('', '', false, true);
                  }}
                  sx={{ mb: 1 }}>
                  Replace
                </Button>
              )}
              <IconButton
                sx={{
                  p: 0,
                  pr: 0.5,
                  ':hover': {
                    bgcolor: '#F4FCFC',
                  },
                  cursor: 'pointer',
                  pointerEvents: 'all',
                  mb: 1,
                }}
                onClick={() => window.open(documentData.file?.url, '_blank')}>
                <CardMedia
                  component="img"
                  src={'/images/download-icon.png'}
                  alt="Download"
                  sx={{ width: '25px' }}
                />
              </IconButton>
            </Box>
          </Box>
        </>
      )}
      <FileUploadDialog
        handleClose={handleClose}
        show={open.show}
        message={open.message}
        code={open.code}
      />
      {!!errorText && (
        <Typography
          component="span"
          sx={{
            color: '#d32f2f',
            fontSize: '0.75rem',
          }}>
          {errorText}
        </Typography>
      )}
    </>
  );
};

export type documentDetails = {
  documentType: string;
  documentName: string;
  documentId: string;
  loading?: boolean;
  isActive: boolean;
  file?: FileType;
  fileView?: FileType;
  required?: string;
  uniqueKey?: string;
  options?: string[];
  id?: number;
  errorOnUpload?: boolean;
  sameAsProofOfIdentity?: boolean;
  documentNumber?: string | null;
  documentExpiryDate?: null | string;
  [key: string]: string | number | boolean | string[] | FileType | null | undefined;
};

type documentProps = {
  documents: {
    documentType: string;
    documentName: string;
    documentsList: documentDetails[];
    multipleFiles: string;
    required: string;
    options?: string[];
  }[];
  userId?: string;
  kraDocument?: KraDocumentType[];
  status?: string;
};

type nomineeDocumentProps = {
  nomineedocuments: {
    documentType: string;
    documentName: string;
    documentsList: documentDetails[];
    multipleFiles: string;
    required: string;
    options?: string[];
  }[];
};
export interface Values {
  applicants: documentProps[];
  nominees: nomineeDocumentProps[];
  saveType: string;
  banks: Bank[];
  hasPOA: boolean;
  [key: string]:
    | documentProps[]
    | string
    | undefined
    | string[]
    | Bank[]
    | boolean
    | nomineeDocumentProps[];
}
export const document_object = {
  documentId: '',
  isActive: true,
  errorOnUpload: false,
};

export const getDocAndCustodianData = (
  custodian: string,
  applicant: Partial<Applicant>,
  hasPOA: boolean,
  checkNdpmsFlow: boolean
): { docData: string; custodianDoc: string } => {
  let docData = '';
  let custodianDoc = '';
  if (isCustodianHDFC(custodian)) {
    custodianDoc = APPLICATION_TYPE_FOR_DOCUMENTS.HDFC;
  }
  if (isCustodianAxis(custodian)) {
    custodianDoc = APPLICATION_TYPE_FOR_DOCUMENTS.AXIS;
  }
  if (isCustodianKotak(custodian)) {
    custodianDoc = APPLICATION_TYPE_FOR_DOCUMENTS.Kotak;
  }
  if (
    !hasPOA &&
    applicantStatusMasters[applicant.status as string] === applicantStatusMasters.Individual
  ) {
    docData = APPLICATION_TYPE_FOR_DOCUMENTS.INDIVIDUAL;
  }
  if (
    hasPOA &&
    applicantStatusMasters[applicant.status as string] === applicantStatusMasters.Individual
  ) {
    docData = APPLICATION_TYPE_FOR_DOCUMENTS.INDIVIDUAL_POA;
  }
  if (!hasPOA && isApplicantNRI(applicant.status as string)) {
    docData = APPLICATION_TYPE_FOR_DOCUMENTS.NRI;
  }
  if (hasPOA && isApplicantNRI(applicant.status as string)) {
    docData = APPLICATION_TYPE_FOR_DOCUMENTS.NRI_POA;
  }
  if (checkNdpmsFlow) {
    docData = APPLICATION_TYPE_FOR_DOCUMENTS.NDPSM_DOC;
  }
  return { docData, custodianDoc };
};

export default function DocumentDetails(): JSX.Element {
  const [loading, setLoading] = useState(false);
  const { application } = useSelector((store: RootStateType) => store.application);
  const { role = '', id: authId = '' } = useSelector((store: RootStateType) => store.auth);
  const referenceDetail = useSelector((store: RootStateType) => store.refrenceIdReducer);
  const dispatch = useDispatch();
  const history = useHistory();
  const [documentUpload, setDocumentUpload] = useState(false);
  const { investorEditObj } = useSelector((store: RootStateType) => store.investorEditObj);
  const [investorRouteObj, setInvestorRouteObj] = useState<InvestorEditRouteLinkObj | null>(null);
  const [openPopup, setOpenPopup] = useState(false);
  const { path } = useRouteMatch();
  const routeForNDPSM = path === '/application/document-details-ndpms';
  const checkNdpmsFlow = checkNDPMSForIndusindBank(
    application?.accountType,
    application?.bankDetails
  );
  const kycUpdateRouteCheck =
    path === '/investment-details/:referenceId/kyc-update/xmlDocument-details';

  const hideAddressProof = (documentType: string, doc: any): boolean =>
    documentType === 'addressProof' && doc.sameAsProofOfIdentity;

  const handleUpload = () => {
    setDocumentUpload(true);
  };
  const handleUploaded = () => {
    setDocumentUpload(false);
  };
  const [documentsData, setDocumentsData] = useState<Document>();
  const { enqueueSnackbar } = useSnackbar();
  const [custodianData] = useCustodianData();
  const validationOrConfigChecks = useValidationOrConfigHook();
  const filePondRefs = useRef<{ [key: string]: HTMLDivElement | null }>({});

  // Helper to assign ref to a FilePond field
  const setFilePondRef = (name: string) => (el: HTMLDivElement | null) => {
    filePondRefs.current[name] = el;
  };

  const scrollToFilePondField = (fieldName: string): void => {
    const ref = filePondRefs.current[fieldName];
    if (ref && typeof ref.scrollIntoView === 'function') {
      ref.scrollIntoView({ block: 'center', inline: 'start' });
      ref.focus?.();
    }
  };

  useEffect(() => {
    (async function () {
      try {
        const response = (await dispatch(getDocuments())) as unknown as Document;
        setDocumentsData(response as Document);
        const routeLinkObj =
          (investorEditObj && investorEditObj?.length > 0) ||
          (APMIFlow && referenceDetail?.applicant_type === '1')
            ? getInvestorRouteLinks(
                investorEditObj as InvestorEditErrorObj[],
                history?.location?.pathname?.split('/')?.pop() || '',
                referenceDetail
              )
            : null;

        setInvestorRouteObj(routeLinkObj);
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
  }, []);

  const {
    applicants = [],
    banks = [],
    hasPOA = true,
    nominees = [],
    bankAccountFormCreated = false,
    showBankIcon = false,
    ndpmsSectionEdited = false,
    custodian = '',
  } = application || {};
  const shouldShowPan = isPanDocAvaialbleForICICI(
    application?.createdAt || '',
    validationOrConfigChecks?.removePanOptionForICICICustodian,
    custodian || ''
  );

  const initialValues: Values = {
    applicants: applicants.map((applicant, applicant_index) => {
      const { docData, custodianDoc } = getDocAndCustodianData(
        custodian,
        applicant,
        hasPOA,
        checkNdpmsFlow
      );
      return {
        documents:
          typeof documentsData !== 'undefined'
            ? [
                ...mergeDocumentsWithCustodian(
                  (documentsData as Document)[docData] || [],
                  (documentsData as Document)[custodianDoc] || [],
                  custodian
                ),
              ]
                .filter((doc) => {
                  if (
                    hasPOA &&
                    applicant.applicant_type !== '1' &&
                    doc.documentType === 'poaNotarized'
                  ) {
                    return;
                  }
                  if (
                    checkAdvisoryFlow(application?.accountType || '') &&
                    doc.documentType === 'bankAccountProof'
                  ) {
                    return;
                  }
                  return doc;
                })
                .filter((ele) => ele)
                .filter((document) => {
                  if (applicant.amlCheck && document.documentType === 'compliance_document') {
                    return;
                  }
                  return document;
                })
                .filter((ele) => ele)
                .filter((doc) => {
                  if (
                    !applicant.correspondenceAddressEdited &&
                    doc.documentType === 'correspondenceAddress'
                  ) {
                    return;
                  }
                  if (applicant_index > 0 && doc.documentType === 'newBankAccountProof') {
                    return;
                  }
                  return doc;
                })
                .filter((ele) => ele)
                .map((doc) => {
                  if (doc.documentType === 'identityProof' && doc.options) {
                    if (shouldShowPan) {
                      return {
                        ...doc,
                        options: doc.options.filter((option) => !option.includes('Photo PAN Card')),
                      };
                    }
                  }
                  return doc;
                })
                .map((doc) => {
                  if (
                    applicant.correspondenceAddressEdited &&
                    doc.documentType === 'correspondenceAddress'
                  ) {
                    return { ...doc, required: 'true' };
                  }
                  if (isCustodianAxis(custodian) && doc.documentType === 'addressProof') {
                    return { ...doc, required: 'true' };
                  }
                  if (
                    checkNdpmsFlow &&
                    bankAccountFormCreated &&
                    showBankIcon &&
                    routeForNDPSM &&
                    doc.documentType === 'newBankAccountProof'
                  ) {
                    return { ...doc, required: 'true' };
                  }
                  if (
                    checkNdpmsFlow &&
                    bankAccountFormCreated &&
                    !showBankIcon &&
                    !routeForNDPSM &&
                    doc.documentType === 'newBankAccountProof'
                  ) {
                    return { ...doc, required: 'true' };
                  }
                  return doc;
                })
                .map((updateRequired) => {
                  if (
                    updateRequired.documentType === 'investorSignature' &&
                    fieldValidateForInvestor(
                      referenceDetail.applicant_type,
                      applicant_index + 1,
                      false
                    )
                  ) {
                    return {
                      ...updateRequired,
                      required: 'true',
                    };
                  }
                  return updateRequired;
                })
                .map((doc: individuals_Poa_nonIndividuals_Documents, index: number) => {
                  const { documentType, documentName, multipleFiles, required, options } = doc;
                  const { documents: existingDocuments = [] } = applicant || {};
                  const docsOfCurrentDocType = existingDocuments
                    .filter((doc) => doc.documentType === documentType)
                    .sort((doc1, doc2) => Number(doc1.documentId) - Number(doc2.documentId));
                  const defaultDocObj = {
                    documentType,
                    documentName,
                    required,
                    options,
                    documentNumber: null,
                    documentExpiryDate: null,
                    uniqueKey: (applicant_index.toString() +
                      '-' +
                      index.toString() +
                      '-' +
                      '0') as string,
                    ...document_object,
                  };
                  const existingDocObj = docsOfCurrentDocType?.map((doc, ind) => {
                    const {
                      documentName = '',
                      documentType = '',
                      documentId = '',
                      isActive = true,
                      file = undefined,
                      documentNumber = '',
                      documentExpiryDate = '',
                    } = doc;
                    return {
                      id: doc.id,
                      applicantId: doc.applicantId,
                      documentType,
                      documentName: options?.includes(documentName)
                        ? documentName
                        : defaultDocObj?.documentName,
                      documentId,
                      loading: false,
                      documentNumber,
                      documentExpiryDate,
                      isActive,
                      file,
                      options,
                      required:
                        ind === 1 &&
                        !documentNameValidationCheckForMultipleDocumentsMandatory(documentName)
                          ? 'false'
                          : required,
                      uniqueKey: (applicant_index.toString() +
                        '-' +
                        index.toString() +
                        '-' +
                        ind.toString()) as string,
                    };
                  });
                  return {
                    documentType: documentType,
                    documentName: documentName,
                    documentsList: docsOfCurrentDocType.length
                      ? multipleFiles === 'true' && existingDocObj?.length === 1
                        ? [
                            ...existingDocObj,
                            {
                              ...defaultDocObj,
                              documentName: existingDocObj[existingDocObj.length - 1].documentName,
                              required: documentNameValidationCheckForMultipleDocumentsMandatory(
                                existingDocObj[existingDocObj.length - 1].documentName
                              )
                                ? required
                                : 'false',
                              uniqueKey: (applicant_index.toString() +
                                '-' +
                                index.toString() +
                                '-' +
                                '1') as string,
                            },
                          ]
                        : existingDocObj
                      : multipleFiles === 'true'
                      ? [
                          defaultDocObj,
                          {
                            ...defaultDocObj,
                            required: documentNameValidationCheckForMultipleDocumentsMandatory(
                              defaultDocObj.documentName
                            )
                              ? required
                              : 'false',
                            uniqueKey: (applicant_index.toString() +
                              '-' +
                              index.toString() +
                              '-' +
                              '1') as string,
                          },
                        ]
                      : [defaultDocObj],
                    required,
                    multipleFiles,
                    options,
                  };
                })
            : [],
        kraDocument: applicant.kraDocument,
        status: applicant.status,
        userId: applicant?.userId,
      };
    }),
    nominees: nominees.map((nominee, nominee_index) => {
      return {
        nomineedocuments:
          typeof documentsData !== 'undefined'
            ? (isMinor(nominee.dateOfBirth || '')
                ? [
                    ...((documentsData as Document)[APPLICATION_TYPE_FOR_DOCUMENTS.NOMINEE_DOC] ||
                      []),
                    ...((documentsData as Document)[
                      APPLICATION_TYPE_FOR_DOCUMENTS.NOMINEE_GUARDIAN
                    ] || []),
                  ].map((doc) => {
                    if (doc.documentType === 'nomineeIdProof') {
                      return { ...doc, required: 'false' };
                    }
                    if (doc.documentType === 'guardianIdProof') {
                      return { ...doc, required: 'false' };
                    }
                    return doc;
                  })
                : (
                    (documentsData as Document)[APPLICATION_TYPE_FOR_DOCUMENTS.NOMINEE_DOC] || []
                  ).map((_nomineeDoc) => {
                    if (_nomineeDoc.documentType === 'nomineeIdProof') {
                      return { ..._nomineeDoc, required: 'false' };
                    }
                    return _nomineeDoc;
                  })
              ).map((doc: individuals_Poa_nonIndividuals_Documents, index: number) => {
                const { documentType, documentName, multipleFiles, required, options } = doc;
                const { nomineedocuments: existingDocuments = [] } = nominee || {};
                const docsOfCurrentDocType = existingDocuments
                  .filter((doc) => doc.documentType === documentType)
                  .sort((doc1, doc2) => Number(doc1.documentId) - Number(doc2.documentId));
                const defaultDocObj = {
                  documentType,
                  documentName,
                  required,
                  options,
                  uniqueKey: (nominee_index.toString() +
                    '-' +
                    index.toString() +
                    '-' +
                    '0') as string,
                  ...document_object,
                };
                const existingDocObj = docsOfCurrentDocType.map((doc, ind) => {
                  const {
                    documentName = '',
                    documentType = '',
                    documentId = '',
                    isActive = true,
                    file = undefined,
                  } = doc;
                  return {
                    id: doc.id,
                    nomineeId: doc.nomineeId,
                    documentType,
                    documentName,
                    documentId,
                    isActive,
                    file,
                    options,
                    required:
                      ind === 1 &&
                      !documentNameValidationCheckForMultipleDocumentsMandatory(documentName)
                        ? 'false'
                        : required,
                    uniqueKey: (nominee_index.toString() +
                      '-' +
                      index.toString() +
                      '-' +
                      ind.toString()) as string,
                  };
                });
                return {
                  documentType: documentType,
                  documentName: documentName,
                  documentsList: docsOfCurrentDocType.length
                    ? multipleFiles === 'true' && existingDocObj?.length === 1
                      ? [
                          ...existingDocObj,
                          {
                            ...defaultDocObj,
                            documentName: existingDocObj[existingDocObj.length - 1].documentName,
                            required: documentNameValidationCheckForMultipleDocumentsMandatory(
                              existingDocObj[existingDocObj.length - 1].documentName
                            )
                              ? required
                              : 'false',
                            uniqueKey: (nominee_index.toString() +
                              '-' +
                              index.toString() +
                              '-' +
                              '1') as string,
                          },
                        ]
                      : existingDocObj
                    : multipleFiles === 'true'
                    ? [
                        defaultDocObj,
                        {
                          ...defaultDocObj,
                          required: documentNameValidationCheckForMultipleDocumentsMandatory(
                            defaultDocObj.documentName
                          )
                            ? required
                            : 'false',
                          uniqueKey: (nominee_index.toString() +
                            '-' +
                            index.toString() +
                            '-' +
                            '1') as string,
                        },
                      ]
                    : [defaultDocObj],
                  required,
                  multipleFiles,
                  options,
                };
              })
            : [],
      };
    }),
    saveType: 'save and proceed',
    banks: banks,
    hasPOA: hasPOA,
  };
  const updatedApplicants = (
    exisitingApplicants: Partial<Applicant>[],
    applicants: documentProps[]
  ): Partial<Applicant>[] => {
    return exisitingApplicants.map((applicant, index) => {
      const { documents = [] } = applicants[index] || {};
      const updated = documents?.map((document) => {
        if (document.documentType === 'addressProof') {
          const identityProofDoc = documents?.find(
            (element) => element.documentType === 'identityProof'
          );
          if (identityProofDoc) {
            return {
              ...document,
              documentsList: document.documentsList.map((_document, index) => {
                if (hideAddressProof(_document.documentType, _document)) {
                  const {
                    documentName: idProofDocumentName,
                    documentId: idProofDocumentId,
                    documentNumber: idProofDocumentNumber,
                    documentExpiryDate: idProofDocumentExpiryDate,
                  } = identityProofDoc.documentsList[index];
                  return {
                    ..._document,
                    documentName: idProofDocumentName,
                    documentId: idProofDocumentId,
                    documentNumber: idProofDocumentNumber,
                    documentExpiryDate: idProofDocumentExpiryDate,
                  };
                }
                return _document;
              }),
            };
          }
        }
        return document;
      });
      const finalDocs = updated?.map((doc) => {
        doc.documentsList.map((_documentCheck) => {
          if (_documentCheck?.errorOnUpload) {
            throw docInvalidCheck;
          }
        });
        const getDoc = doc.documentsList.find(
          (_d) =>
            _d.documentType === doc.documentType && (_d.documentNumber || _d.documentExpiryDate)
        );
        return doc.documentsList
          .map((_updateDoc) => {
            return _updateDoc;
          })
          .map((_doc) => {
            if (getDoc && _doc.documentType === getDoc.documentType) {
              return {
                ..._doc,
                documentNumber: getDoc.documentNumber,
                documentExpiryDate: getDoc.documentExpiryDate,
              };
            }
            return _doc;
          })
          .filter((d) => d.documentId);
      });
      const getTypedDeclaration = applicant?.documents?.find(
        (_doc) => _doc.documentType === 'typedDeclaration' && _doc.documentId
      );
      let updateFinalDoc = finalDocs.flat();
      if (getTypedDeclaration) {
        updateFinalDoc = [
          ...updateFinalDoc,
          { ...getTypedDeclaration, uniqueKey: '', required: '' },
        ] as documentDetails[];
      }
      return {
        ...applicant,
        documents: updateFinalDoc.map((doc) => {
          const { uniqueKey, required, errorOnUpload, ...rest } = doc;
          return rest;
        }),
      };
    }) as Partial<Applicant>[];
  };

  const updatedNominees = (
    existingNominees: NomineeType[],
    nominees: nomineeDocumentProps[]
  ): NomineeType[] => {
    return existingNominees.map((nominee, index) => {
      const { nomineedocuments = [] } = nominees[index] || {};
      const finalDocs = nomineedocuments?.map((doc) => {
        doc.documentsList.map((_nomineeDocumentCheck) => {
          if (_nomineeDocumentCheck?.errorOnUpload) {
            throw docInvalidCheck;
          }
        });
        const getDoc = doc.documentsList.find((_d) => _d.documentType === doc.documentType);
        return doc.documentsList
          .map((_updateDoc) => {
            return _updateDoc;
          })
          .map((_doc) => {
            if (getDoc && _doc.documentType === getDoc.documentType) {
              return {
                ..._doc,
              };
            }
            return _doc;
          })
          .filter((d) => d.documentId);
      });
      return {
        ...nominee,
        nomineedocuments: finalDocs.flat().map((doc) => {
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          const { uniqueKey, required, errorOnUpload, ...rest } = doc;
          return rest;
        }),
      };
    }) as NomineeType[];
  };
  const { esignReferenceId } = referenceDetail;
  const { referenceId: referenceIdForInvestorPhotoCapture } = useParams<{ referenceId: string }>();
  const responceMaskAadhar = async (doc: any, getDocument: any, params: MaskedAadharBody) => {
    if (
      doc.documentName.toLowerCase() === 'aadhaar card(masked by system)' &&
      doc.documentId &&
      (getDocument?.documentName !== doc.documentName || !doc.file)
    ) {
      const maskedAadharResponse = (await dispatch(
        getMaskedAadhar(params)
      )) as unknown as MaskedAadharResponse;
      return {
        ...doc,
        documentId: maskedAadharResponse.id,
      };
    }
    return doc;
  };

  const maskAadhaar = async (applicant: Partial<Applicant>, index: any) => {
    if (!applicant.documents) return;

    const updatedDocs: DocumentType[] = [];

    for (const doc of applicant.documents) {
      const existingApplicant = application?.applicants[index];
      const getDocument = existingApplicant?.documents?.find(
        (document) => document.documentType === doc.documentType
      );

      const updatedDoc = await responceMaskAadhar(doc, getDocument, {
        fileId: doc.documentId || '',
        applicationId: application?.id || '',
        applicantId: applicant.id || '',
      });

      updatedDocs.push(updatedDoc);
    }

    return updatedDocs;
  };

  const maskAadhaarForNominee = async (nominee: NomineeType, index: any) => {
    if (!nominee.nomineedocuments) return;

    const updatedDocs: DocumentType[] = [];

    for (const doc of nominee.nomineedocuments) {
      const existingNominee = application?.nominees[index];
      const getDocument = existingNominee?.nomineedocuments?.find(
        (document) => document.documentType === doc.documentType
      );

      const updatedDoc = await responceMaskAadhar(doc, getDocument, {
        fileId: doc.documentId || '',
        applicationId: application?.id || '',
        nomineeId: nominee.id || '',
      });

      updatedDocs.push(updatedDoc);
    }

    return updatedDocs;
  };

  const amcuserAsInvestor = refLoginCheck(
    authId,
    application as unknown as ApplicationProps,
    referenceDetail
  );

  const hasInvestorSignature = (values: Values) => {
    const activeApplicant = values.applicants.find((_applicant) => {
      return Number(_applicant?.userId) === Number(authId);
    });

    if (!activeApplicant) return false;

    return activeApplicant.documents.some((document) =>
      document.documentsList.some((doc) => doc.documentType === 'investorSignature' && doc.file?.id)
    );
  };

  const handleSubmit = async (values: Values) => {
    try {
      if (
        shouldValidateUponSaveLater(values.saveType) &&
        role !== USER_ROLES.INVESTOR &&
        !amcuserAsInvestor
      ) {
        setLoading(true);
        const nationalitiesMdmsMasters = (await dispatch(
          getNationalityList()
        )) as unknown as nationaliyType;
        const strategiesResponse = (await getAllStrategiesByDistributorType(
          dispatch,
          application as ApplicationProps
        )) as unknown as GetStrategiesResponseBody[];
        const responseRiskProfile = (await dispatch(
          riskProfileMasterData()
        )) as unknown as RiskProfileMaster;
        setLoading(false);

        await isFormValidForSubmission(
          application,
          false,
          true,
          nationalitiesMdmsMasters,
          custodianData,
          validationOrConfigChecks,
          documentsData,
          role,
          responseRiskProfile.riskProfile,
          strategiesResponse,
          referenceDetail,
          !checkBankAccoutFieldEnableOrDisalble(
            checkNdpmsFlow,
            routeForNDPSM,
            bankAccountFormCreated,
            showBankIcon
          ),
          routeForNDPSM
        );
      }
      const {
        applicants: exisitingApplicants = [],
        id,
        applicant1ReferenceId,
        currentStep,
        status,
        applicationNumber,
        nominees: existingNominees = [],
      } = application || {};
      const { applicants, saveType, hasPOA, nominees } = values;
      // const updatedApplicants = exisitingApplicants.map((applicant, index) => {
      //   const applicantsWithNoDocsAttached = Object.keys(applicants[index].documents).filter(
      //     (doc) => applicants[index].documents[doc].documentId
      //   );
      //   return {
      //     ...applicant,
      //     countryCode: '+91', //For now hard coding country code. Need to remove after UI is done
      //     documents: applicantsWithNoDocsAttached.map((documentType) => ({
      //       ...getExistingDocuments(exisitingApplicants[index].documents || [], documentType),
      //       ...applicants[index].documents[documentType],
      //     })),
      //   };
      // });
      const updatedApplicantsWithDoc = updatedApplicants(exisitingApplicants, applicants).map(
        (applicant) => {
          if (applicant.documents?.length) {
            applicant.documents = applicant.documents.map((document) => {
              const updatedDocument = {
                ...document,
                documentExpiryDate: documentNameValidationCheckForDocumentExpiryDate(
                  document.documentName
                )
                  ? document.documentExpiryDate
                  : null,
              };

              if (
                updatedDocument.options &&
                !updatedDocument.options.includes(updatedDocument.documentName)
              ) {
                throw `Please Select ${getFieldTitle[updatedDocument.documentType]}`;
              }

              return updatedDocument;
            });
          }
          return applicant;
        }
      );
      const isSaveLater = saveType !== 'save and proceed';
      const updatedNomineesWithDoc = updatedNominees(existingNominees, nominees).map((_nominee) => {
        if (_nominee.nomineedocuments?.length) {
          _nominee.nomineedocuments = _nominee.nomineedocuments.map((document) => {
            if (document.options && !document.options.includes(document.documentName)) {
              throw `Please Select ${getFieldTitle[document.documentType]}`;
            }
            return {
              ...document,
            };
          });
        }
        return _nominee;
      });

      const checkApplication = applicationComparison(
        {
          ...application,
          applicants: application?.applicants
            ?.map((applicant) => {
              return {
                ...applicant,
                documents: applicant.documents
                  ?.map((document: any) => {
                    const {
                      loading,
                      options,
                      sameAsProofOfIdentity,
                      filename,
                      createdBy,
                      updatedBy,
                      createdAt,
                      updatedAt,
                      ...rest
                    } = document;
                    return { ...rest };
                  })
                  .sort((doc1, doc2) => Number(doc1.documentId) - Number(doc2.documentId)),
              };
            })
            .sort((applicant1, applicant2) => Number(applicant1.id) - Number(applicant2.id)),
          nominees: application?.nominees
            ?.map((nominee) => {
              return {
                ...nominee,
                nomineedocuments: nominee.nomineedocuments
                  ?.map((document: any) => {
                    const {
                      id,
                      nomineeId,
                      documentType,
                      documentName,
                      documentId,
                      isActive,
                      file,
                    } = document;
                    return {
                      id,
                      nomineeId,
                      documentType,
                      documentName,
                      documentId,
                      isActive,
                      file,
                    };
                  })
                  .sort((doc1, doc2) => Number(doc1.documentId) - Number(doc2.documentId)),
              };
            })
            .sort((nominee1, nominee2) => Number(nominee1.id) - Number(nominee2.id)),
        },
        {
          ...application,
          applicants: updatedApplicantsWithDoc
            .map((applicant) => {
              return {
                ...applicant,
                documents: applicant.documents
                  ?.map((document: any) => {
                    const {
                      loading,
                      options,
                      sameAsProofOfIdentity,
                      filename,
                      createdBy,
                      updatedBy,
                      createdAt,
                      updatedAt,
                      ...rest
                    } = document;
                    return { ...rest };
                  })
                  .sort((doc1, doc2) => Number(doc1.documentId) - Number(doc2.documentId)),
              };
            })
            .sort((applicant1, applicant2) => Number(applicant1.id) - Number(applicant2.id)),
          nominees: updatedNomineesWithDoc
            .map((nominee) => {
              return {
                ...nominee,
                nomineedocuments: nominee.nomineedocuments
                  ?.map((document: any) => {
                    const {
                      id,
                      nomineeId,
                      documentType,
                      documentName,
                      documentId,
                      isActive,
                      file,
                    } = document;
                    return {
                      id,
                      nomineeId,
                      documentType,
                      documentName,
                      documentId,
                      isActive,
                      file,
                    };
                  })
                  .sort((doc1, doc2) => Number(doc1.documentId) - Number(doc2.documentId)),
              };
            })
            .sort((nominee1, nominee2) => Number(nominee1.id) - Number(nominee2.id)),
          currentStep: getStep(
            !!currentStep && currentStep > 12 ? currentStep : Number(currentStep) + 1,
            isSaveLater
          ),
        }
      );

      //save for later route for investor at liveliness
      const investorEditSaveelaterRoute =
        referenceIdForInvestorPhotoCapture &&
        saveForLaterInvestorPhotoCapture(referenceIdForInvestorPhotoCapture, application);

      if (id && !checkApplication) {
        setLoading(true);
        const applicantsUpdate = await Promise.all(
          updatedApplicantsWithDoc.map(async (applicant, index) => {
            return {
              ...applicant,
              documents: await maskAadhaar(applicant, index),
            };
          })
        );
        const nomineeUpdate = await Promise.all(
          updatedNomineesWithDoc.map(async (nominee, index) => {
            return {
              ...nominee,
              nomineedocuments: await maskAadhaarForNominee(nominee, index),
            };
          })
        );
        await dispatch(
          updateApplication({
            body: {
              ...application,
              ndpmsSectionEdited: turnEditOnInDoc(
                routeForNDPSM,
                role,
                checkNdpmsFlow,
                showBankIcon,
                bankAccountFormCreated
              )
                ? true
                : application?.ndpmsSectionEdited,
              applicants: applicantsUpdate,
              nominees: nomineeUpdate,
              // : (status === 'draft' || status === 'sent_to_amc_approver') &&
              status:
                !application?.hasPOA &&
                AMC_APPROVER_CHECK_FOR_INDIVIDUAL &&
                applyRoleBasedStatus(role) &&
                !amcuserAsInvestor &&
                status !== 'draft'
                  ? 'sent_to_amc_approver'
                  : status,
              // currentStep: getStep(13, isSaveLater),
              currentStep: investorRouteObj
                ? getStep(currentStep as number, isSaveLater)
                : getStep(13, isSaveLater),
              ...((!SAVE_LATER_VALIDATION_CHECK as boolean) && { saveForLater: isSaveLater }),
              //!!currentStep && currentStep > 8 ? currentStep : Number(currentStep) + 1,
            },
            applicationId: id,
            ...(isSaveLater && {
              toastMessage: '',
            }),
          })
        );
        setLoading(false);
        kycUpdateRouteCheck
          ? history.push(`/investment-details/${esignReferenceId}/application-details`)
          : investorRouteObj
          ? !isSaveLater && !hasInvestorSignature(values)
            ? setOpenPopup(true)
            : investorRouteObj.backSectionLink && !hasInvestorSignature(values)
            ? history.push(investorRouteObj.backSectionLink, {
                id,
                applicant1ReferenceId: esignReferenceId,
              })
            : hasInvestorSignature(values)
            ? history.push(`/investment-details/${esignReferenceId}/application-details`)
            : setOpenPopup(true)
          : referenceIdForInvestorPhotoCapture
          ? history.push(
              investorEditSaveelaterRoute.routePath,
              investorEditSaveelaterRoute.routeState
            )
          : history.push(
              role === USER_ROLES.INVESTOR || amcuserAsInvestor
                ? `/investment-details/${esignReferenceId}/application-details`
                : role === USER_ROLES.POAAPPROVER || USER_ROLES.AMCAPPROVER === role
                ? `/application-details/${id}`
                : isSaveLater
                ? `/applications`
                : `/application-preview/${id}`
            );
      } else if (isSaveLater) {
        enqueueSnackbar(`Application ${applicationNumber} - ` + ' Saved successfully', {
          variant: 'success',
          autoHideDuration: 3000,
        });
        investorRouteObj
          ? !isSaveLater && !hasInvestorSignature(values)
            ? setOpenPopup(true)
            : investorRouteObj.backSectionLink && !hasInvestorSignature(values)
            ? history.push(investorRouteObj.backSectionLink, {
                id,
                applicant1ReferenceId: esignReferenceId,
              })
            : hasInvestorSignature(values)
            ? history.push(`/investment-details/${esignReferenceId}/application-details`)
            : setOpenPopup(true)
          : referenceIdForInvestorPhotoCapture
          ? history.push(
              investorEditSaveelaterRoute.routePath,
              investorEditSaveelaterRoute.routeState
            )
          : history.push(
              role === USER_ROLES.INVESTOR || amcuserAsInvestor
                ? `/investment-details/${esignReferenceId}/application-details`
                : role === USER_ROLES.POAAPPROVER || USER_ROLES.AMCAPPROVER === role
                ? `/application-details/${id}`
                : `/applications`
            );
      } else {
        kycUpdateRouteCheck
          ? history.push(`/investment-details/${esignReferenceId}/application-details`)
          : investorRouteObj
          ? !isSaveLater && !hasInvestorSignature(values)
            ? setOpenPopup(true)
            : investorRouteObj.backSectionLink && !hasInvestorSignature(values)
            ? history.push(investorRouteObj.backSectionLink, {
                id,
                applicant1ReferenceId: esignReferenceId,
              })
            : hasInvestorSignature(values)
            ? history.push(`/investment-details/${esignReferenceId}/application-details`)
            : setOpenPopup(true)
          : referenceIdForInvestorPhotoCapture
          ? history.push(
              investorEditSaveelaterRoute.routePath,
              investorEditSaveelaterRoute.routeState
            )
          : history.push(
              role === USER_ROLES.INVESTOR || amcuserAsInvestor
                ? `/investment-details/${esignReferenceId}/application-details`
                : role === USER_ROLES.POAAPPROVER || USER_ROLES.AMCAPPROVER === role
                ? `/application-details/${id}`
                : `/application-preview/${id}`
            );
      }
    } catch (e) {
      setLoading(false);
      typeof e === 'string' && dispatch(showError(e));
      console.error((e as Error).message);
    }
  };

  const isFieldDisabled = [USER_ROLES.POAAPPROVER].includes(role);
  const getLabel = (
    documentName: string,
    documentType: string,
    required: string,
    values: Values,
    ind: number
  ): string => {
    return `${documentName}  ${
      isPhygital(application as ApplicationProps) && documentType === 'investorSignature'
        ? '*'
        : documentType === 'bankAccountProof'
        ? (values.banks.filter(
            (bank) => !bank.pennydropVerified && bank.defaultBankAccount && !checkNdpmsFlow
          ).length !== 0 &&
            ind === 0) ||
          isApplicantNRI(values.applicants[ind]?.status || '')
          ? '*'
          : ''
        : required === 'true'
        ? '*'
        : ''
    } `;
  };
  const loginType = useSelector((store: RootStateType) => store.auth.role);

  const handleSubmitForInvestor = async (values: Values) => {
    if (loginType !== USER_ROLES.INVESTOR || hasInvestorSignature(values)) {
      handleSubmit(values);
    } else {
      setOpenPopup(true);
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmitForInvestor}
      //validationSchema={documentDetailsSchema}
      validate={(values: Values) => {
        const shouldSaveForLater = shouldValidateUponSaveLater(values.saveType);
        try {
          validateYupSchema(
            values,
            referenceDetail.applicant_type
              ? documentDetailsSchemaForInvestorLogin(
                  shouldSaveForLater,
                  role,
                  referenceDetail.applicant_type
                )
              : documentDetailsSchema(
                  !checkNdpmsFlow,
                  shouldSaveForLater,
                  application?.editedByPrimaryApplicant
                ),
            true,
            { ...values, application }
          );
        } catch (e) {
          return yupToFormErrors(e);
        }
      }}
      enableReinitialize={true}>
      {({
        handleSubmit: formikHandleSubmit,
        values,
        setValues,
        validateForm,
        setTouched,
        setErrors,
        setFieldValue,
        errors,
      }) => (
        <Grid
          container
          rowSpacing={1}
          columnSpacing={10}
          component="form"
          noValidate
          onSubmit={formikHandleSubmit}
          sx={{
            width: '100%',
            ml: 0,
            '.MuiGrid-item': { px: { xs: 0, sm: '30px' } },
          }}>
          <Grid sx={{ width: '100%' }}>
            {referenceDetail.applicant_type ? (
              <>
                <Notes displayContent={"Please don't upload any password protected files"} />
              </>
            ) : (
              <>
                <Notes
                  displayContent={
                    "Please upload latest documents not more than 2 months old. Please don't upload any password protected files"
                  }
                />
                <NotesWithText
                  displayContent={'Min Size: 2KB, Max Size: 2MB. Supports: png, jpg, jpeg, pdf'}
                />
              </>
            )}
          </Grid>
          {values.applicants.map((applicant, ind) => {
            const { documents } = applicant;
            return !checkEditiable(
              referenceDetail.applicant_type,
              role,
              ind + 1,
              amcuserAsInvestor
            ) ? (
              <>
                {' '}
                <SubHeading>Applicant {ind + 1} Document Details</SubHeading>
                {documents.map((document, doc_index) => {
                  if (
                    !!referenceDetail.referenceId &&
                    document.documentType !== 'investorSignature' &&
                    document.documentType !== 'investorOldSignature'
                  )
                    return <></>;
                  const {
                    documentType,
                    documentName,
                    documentsList = [],
                    multipleFiles,
                    options,
                    required,
                  } = document;
                  return (
                    <React.Fragment key={ind}>
                      <Grid item xs={12} md={6}>
                        {options &&
                          documentsList
                            .filter(
                              (document, index) =>
                                documentsList.findIndex(
                                  (obj) => document.documentType === obj.documentType
                                ) === index
                            )
                            .map((doc: any, index: number) => (
                              <React.Fragment key={index}>
                                {!hideAddressProof(documentType, doc) && (
                                  <>
                                    <Grid xs={12} sm={12}>
                                      <MFSelectField
                                        name={`applicants.${ind}.documents.${doc_index}.documentsList.${index}.documentName`}
                                        label={getLabel(
                                          documentName?.includes('(')
                                            ? documentName?.split('(')[0]
                                            : documentName,
                                          documentType,
                                          required,
                                          values,
                                          ind
                                        )}
                                        items={options.map((item: string) => ({
                                          key: item,
                                          value: item,
                                        }))}
                                        disabled={
                                          isFieldDisabled ||
                                          checkEditiable(
                                            referenceDetail.applicant_type,
                                            role,
                                            ind + 1,
                                            amcuserAsInvestor
                                          ) ||
                                          (documentType === 'addressProof' &&
                                            doc.sameAsProofOfIdentity) ||
                                          isBankAccountProofUploadedFromBankSection(
                                            ind,
                                            documentType,
                                            banks
                                          )
                                        }
                                        applyLabelStyles={true}
                                        onChange={({
                                          target: { value },
                                        }: SelectChangeEvent<unknown>) => {
                                          const updatedDocumentList = values.applicants[
                                            ind
                                          ].documents[doc_index].documentsList.map((docList) => {
                                            if (docList.documentType === doc.documentType) {
                                              return {
                                                ...docList,
                                                required:
                                                  Number(docList.uniqueKey?.split('-')[2]) === 1 &&
                                                  !documentNameValidationCheckForMultipleDocumentsMandatory(
                                                    value as string
                                                  )
                                                    ? 'false'
                                                    : required,
                                                documentName: value,
                                              };
                                            }
                                            return docList;
                                          });

                                          setFieldValue(
                                            `applicants.${ind}.documents.${doc_index}.documentsList`,
                                            updatedDocumentList
                                          );
                                        }}
                                      />
                                      <Typography
                                        component="span"
                                        sx={{
                                          fontSize: 12,
                                          opacity: 0.7,
                                          // mt: -1,
                                          fontWeight: 500,
                                          color: '#131836',
                                        }}>
                                        {documentName?.includes('(') &&
                                          documentName?.split('(')[1].replace(')', '')}
                                      </Typography>
                                    </Grid>
                                  </>
                                )}
                              </React.Fragment>
                            ))}
                        {!options && (
                          <Typography
                            component="span"
                            sx={{
                              color: 'primary.main',
                              fontWeight: 500,
                              mt: isInvestorOldOrNew(documentType, custodian) ? 4 : 6,
                            }}>
                            {getLabel(documentName, documentType, required, values, ind)}
                            {(documentType === 'investorOldSignature' ||
                              documentType === 'investorSignature') && (
                              <>
                                <Typography
                                  component="span"
                                  sx={{
                                    color: 'primary.main',
                                    fontWeight: 400,
                                    fontSize: 14,
                                  }}>
                                  (Supports: png, jpg, jpeg.
                                  {isCustodianICICI(custodian) || isCustodianHDFC(custodian)
                                    ? ` Max Size: 1MB`
                                    : ''}
                                  )
                                </Typography>
                                {subHeadingForDocumentDetails.find(
                                  (item) => item.documentType === documentType
                                )?.subheading && (
                                  <Typography
                                    component="span"
                                    sx={{
                                      mt: 1,
                                      fontSize: 12,
                                      opacity: 0.7,
                                      fontWeight: 500,
                                      color: '#4D4D4D',
                                    }}>
                                    {
                                      subHeadingForDocumentDetails.find(
                                        (item) => item.documentType === documentType
                                      )?.subheading
                                    }
                                  </Typography>
                                )}
                              </>
                            )}
                          </Typography>
                        )}
                      </Grid>
                      <Grid item xs={12} md={6}>
                        {documentsList.map((doc, index) => {
                          const hideReplace =
                            isBankAccountProofUploadedFromBankSection(
                              ind,
                              doc.documentType,
                              banks
                            ) ||
                            (kycUpdateRouteCheck &&
                              isInvestorOldOrNew(doc.documentType, custodian)) ||
                            (USER_ROLES.INVESTOR === role &&
                              doc?.documentType !== 'investorOldSignature' &&
                              doc?.documentId);
                          return (
                            <React.Fragment key={doc.uniqueKey}>
                              {!hideAddressProof(documentType, doc) && (
                                <>
                                  <Box
                                    ref={setFilePondRef(
                                      `applicants.${ind}.documents.${doc_index}.documentsList.${index}.documentId`
                                    )}>
                                    <FileUpload
                                      onFileChange={(
                                        value,
                                        documentId,
                                        errorOnUpload,
                                        removeFile
                                      ) => {
                                        const { file, ...rest } =
                                          values.applicants[ind].documents[doc_index].documentsList[
                                            index
                                          ];
                                        setFieldValue(
                                          `applicants.${ind}.documents.${doc_index}.documentsList.${index}`,
                                          {
                                            ...rest,
                                            documentId,
                                            ...(!removeFile && { file }),
                                            errorOnUpload:
                                              errorOnUpload || document_object.errorOnUpload,
                                          }
                                        );
                                      }}
                                      name={`applicants.${ind}.documents.${doc_index}.documentsList.${index}.documentId`}
                                      documentData={doc}
                                      disabled={false}
                                      // disabled={
                                      //   isFieldDisabled ||
                                      //   checkEditiable(
                                      //     referenceDetail.applicant_type,
                                      //     role,
                                      //     ind + 1,
                                      //     amcuserAsInvestor
                                      //   )
                                      // }
                                      onFileUpload={handleUpload}
                                      onFileUploaded={handleUploaded}
                                      // displayReplaceButton={!hideReplace}
                                      multipleFiles={multipleFiles}
                                      index={index}
                                      documentsLength={documentsList.length}
                                    />
                                  </Box>
                                </>
                              )}
                            </React.Fragment>
                          );
                        })}
                      </Grid>
                      {documentTypeValidationCheckForDocumentNumberDocumentExpiryDate(
                        documentType
                      ) &&
                        documentsList
                          .filter(
                            (document, index) =>
                              documentsList.findIndex(
                                (obj) => document.documentType === obj.documentType
                              ) === index
                          )
                          .map((doc: any, index: number) => (
                            <>
                              {!hideAddressProof(documentType, doc) && (
                                <>
                                  <Grid item xs={12} sm={6}>
                                    {documentType !== 'correspondenceAddress' && (
                                      <MFTextField
                                        name={`applicants.${ind}.documents.${doc_index}.documentsList.${index}.documentNumber`}
                                        label={`${
                                          documentType === 'identityProof'
                                            ? 'Identification'
                                            : 'Document'
                                        } Number${
                                          checkDocumentNameInOptions(
                                            doc.documentName,
                                            (doc.options || []) as string[]
                                          ) || checkRequired(doc.required || '')
                                            ? ' *'
                                            : ''
                                        }`}
                                        placeholder={`Enter ${
                                          documentType === 'identityProof'
                                            ? 'Identification'
                                            : 'Document'
                                        } Number`}
                                        disabled={
                                          documentType === 'addressProof' &&
                                          doc.sameAsProofOfIdentity
                                        }
                                      />
                                    )}
                                  </Grid>
                                  <Grid item xs={12} sm={6}>
                                    {documentNameValidationCheckForDocumentExpiryDate(
                                      doc.documentName
                                    ) && (
                                      <TextDatePicker
                                        label={`Expiry Date ${
                                          documentNameValidationCheckForDocumentExpiryDate(
                                            doc.documentName
                                          )
                                            ? '*'
                                            : ''
                                        }`}
                                        inputLabelStyles={{
                                          transform: 'unset',
                                          fontSize: 14,
                                          fontWeight: 500,
                                          color: 'rgba(0,0,0,0.7)',
                                        }}
                                        placeholder={'DD/MM/YYYY'}
                                        maxDate={
                                          new Date(
                                            new Date().setFullYear(new Date().getFullYear() + 120)
                                          )
                                        }
                                        minDate={new Date(new Date().setDate(new Date().getDate()))}
                                        disabled={
                                          documentType === 'addressProof' &&
                                          doc.sameAsProofOfIdentity
                                        }
                                        name={`applicants.${ind}.documents.${doc_index}.documentsList.${index}.documentExpiryDate`}
                                      />
                                    )}
                                  </Grid>
                                </>
                              )}
                            </>
                          ))}
                    </React.Fragment>
                  );
                })}
                {ENABLE_KRA_DOCUMENT_FETCH && !referenceDetail.referenceId && (
                  <KraDocument KraDocument={applicant.kraDocument} />
                )}
                {kycUpdateRouteCheck &&
                  referenceDetail &&
                  referenceDetail?.aadharXMLFromDigiLockerFileId && (
                    <KraDocument XMLFile={referenceDetail?.aadharXMLFromDigiLockerFile} />
                  )}
              </>
            ) : (
              <></>
            );
          })}
          {nomineeDocEditCheck(referenceDetail.applicant_type, role) &&
            values.nominees.map((nominee, ind) => {
              // if (referenceDetail.referenceId) return;

              const { nomineedocuments } = nominee;

              return (
                <>
                  {' '}
                  {nomineedocuments.length !== 0 && (
                    <SubHeading>
                      {' '}
                      {getApplicantName(ind + 1, true)} Nominee Document Details
                    </SubHeading>
                  )}
                  {nomineedocuments.map((document, doc_index) => {
                    const {
                      documentType,
                      documentName,
                      documentsList = [],
                      multipleFiles,
                      options,
                      required,
                    } = document;
                    return (
                      <React.Fragment key={ind}>
                        <Grid item xs={12} sm={6}>
                          {options &&
                            documentsList
                              .filter(
                                (_document, index) =>
                                  documentsList.findIndex(
                                    (_obj) => _document.documentType === _obj.documentType
                                  ) === index
                              )
                              .map((doc, index) => (
                                <React.Fragment key={index}>
                                  <Grid xs={12} sm={12}>
                                    <MFSelectField
                                      name={`nominees.${ind}.nomineedocuments.${doc_index}.documentsList.${index}.documentName`}
                                      label={getLabel(
                                        documentName,
                                        documentType,
                                        required,
                                        values,
                                        ind
                                      )}
                                      items={options.map((item: string) => ({
                                        key: item,
                                        value: item,
                                      }))}
                                      applyLabelStyles={true}
                                      disabled={checkEditiable(
                                        referenceDetail.applicant_type,
                                        role,
                                        ind + 1,
                                        amcuserAsInvestor
                                      )}
                                      onChange={({
                                        target: { value },
                                      }: SelectChangeEvent<unknown>) => {
                                        const updatedDocumentList = values.nominees[
                                          ind
                                        ].nomineedocuments[doc_index].documentsList.map(
                                          (docList) => {
                                            if (docList.documentType === doc.documentType) {
                                              return {
                                                ...docList,
                                                required:
                                                  Number(docList.uniqueKey?.split('-')[2]) === 1 &&
                                                  !documentNameValidationCheckForMultipleDocumentsMandatory(
                                                    value as string
                                                  )
                                                    ? 'false'
                                                    : required,
                                                documentName: value,
                                              };
                                            }
                                            return docList;
                                          }
                                        );

                                        setFieldValue(
                                          `nominees.${ind}.nomineedocuments.${doc_index}.documentsList`,
                                          updatedDocumentList
                                        );
                                      }}
                                    />
                                  </Grid>
                                </React.Fragment>
                              ))}
                          {!options && (
                            <Typography
                              component="span"
                              sx={{
                                color: 'primary.main',
                                fontWeight: 500,
                                mt: isInvestorOldOrNew(documentType, custodian) ? 4 : 6,
                              }}>
                              {getLabel(documentName, documentType, required, values, ind)}
                            </Typography>
                          )}
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          {documentsList.map((doc, index) => (
                            <React.Fragment key={doc.uniqueKey}>
                              <Box
                                ref={setFilePondRef(
                                  `nominees.${ind}.nomineedocuments.${doc_index}.documentsList.${index}.documentId`
                                )}>
                                <FileUpload
                                  onFileChange={(value, documentId, errorOnUpload, removeFile) => {
                                    const { file, ...rest } =
                                      values.nominees[ind].nomineedocuments[doc_index]
                                        .documentsList[index];
                                    setFieldValue(
                                      `nominees.${ind}.nomineedocuments.${doc_index}.documentsList.${index}`,
                                      {
                                        ...rest,
                                        documentId,
                                        ...(!removeFile && { file }),
                                        errorOnUpload:
                                          errorOnUpload || document_object.errorOnUpload,
                                      }
                                    );
                                  }}
                                  name={`nominees.${ind}.nomineedocuments.${doc_index}.documentsList.${index}.documentId`}
                                  documentData={doc}
                                  disabled={false}
                                  // disabled={
                                  //   // isFieldDisabled ||
                                  //   // checkEditiable(
                                  //   //   referenceDetail.applicant_type,
                                  //   //   role,
                                  //   //   ind + 1,
                                  //   //   amcuserAsInvestor
                                  //   // )
                                  // }
                                  onFileUpload={handleUpload}
                                  onFileUploaded={handleUploaded}
                                  multipleFiles={multipleFiles}
                                  index={index}
                                  documentsLength={documentsList.length}
                                />
                              </Box>
                            </React.Fragment>
                          ))}
                        </Grid>
                      </React.Fragment>
                    );
                  })}
                </>
              );
            })}
          {(APMIFlow
            ? !referenceDetail?.applicant_type
            : !(
                (investorRouteObj && investorRouteObj.saveAndProceedSectionLink) ||
                kycUpdateRouteCheck
              )) && (
            <FieldValidationNote
              saveType={
                investorRouteObj
                  ? investorRouteObj.saveAndProceedSectionLink
                    ? 'Save and Proceed'
                    : 'Save Application'
                  : isFieldDisabled || USER_ROLES.AMCAPPROVER === role
                  ? 'Save Application'
                  : 'Preview'
              }
            />
          )}

          <ProceedSaveLater
            showEndIcon={false}
            saveLater={() => {
              setTimeout(() => {
                const firstErrorField = getFirstErrorField(errors);
                if (firstErrorField && filePondRefs.current[firstErrorField]) {
                  scrollToFilePondField(firstErrorField);
                }
                scrollToFieldByName(firstErrorField || '');

                setFieldValue('saveType', 'save for later');
              }, 0);
            }}
            loader={loading}
            clickedButton={values.saveType}
            disabled={documentUpload}
            saveAndProceed={() => {
              setTimeout(() => {
                const firstErrorField = getFirstErrorField(errors);
                if (firstErrorField && filePondRefs.current[firstErrorField]) {
                  scrollToFilePondField(firstErrorField);
                }
                scrollToFieldByName(firstErrorField || '');
                setFieldValue('saveType', 'save and proceed');
              }, 0);
            }}
            saveForLaterButtonText={
              investorRouteObj
                ? investorRouteObj.backSectionLink
                  ? `Save and Back To ${investorRouteObj.backSectionName}`
                  : 'Save For Later'
                : 'Save For Later'
            }
            saveButtonText={
              kycUpdateRouteCheck
                ? 'Proceed'
                : investorRouteObj
                ? investorRouteObj.saveAndProceedSectionLink
                  ? 'Save and Proceed'
                  : 'Save Application'
                : isFieldDisabled || USER_ROLES.AMCAPPROVER === role
                ? 'Save Application'
                : 'Preview'
            }
            showSaveForLater={
              kycUpdateRouteCheck
                ? !kycUpdateRouteCheck
                : investorRouteObj
                ? investorRouteObj.backSectionLink
                  ? true
                  : false
                : USER_ROLES.AMCAPPROVER === role
                ? false
                : true
            }
          />
          <ConfirmationDialog
            message={`Application Saved successfully and no further edits provided, Are you sure you want to go back to preview?`}
            open={openPopup}
            setOpen={() => {
              setOpenPopup(false);
            }}
            onSave={async () => {
              setOpenPopup(false);
              await handleSubmit(values);
              history.push(`/investment-details/${esignReferenceId}/application-details`);
            }}
            onCancel={() => {
              setOpenPopup(false);
            }}
          />
        </Grid>
      )}
    </Formik>
  );
}
